import * as React from "react";
const SvgCheckCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, rx: 8, fill: "currentColor", style: {
  fill: "currentColor",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M11 6L7 10L5 8", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheckCircle;
